import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { t } from '../../../app/i18n';
import { Link } from 'react-router';
import Table from 'antd/lib/table';
import Select from 'antd/lib/select';
import Button from 'antd/lib/button';
import { ResponsiveTable, OpenFileLink } from '../../../common/components/data-display';
import { Search } from '../../account-management/components/filters';
import { loanStatusT, loanHistoryStatus, encashmentStatusT, loanAttributeT } from '../../../common/enums';
import { Row, Col } from 'react-flexbox-grid';
import { currencyFormatter, formatDateTime } from '../../../common/utils/helpers';
import CommunicationHelper from './CommunicationHelper';
import LoanHistoryContainer from '../containers/LoanHistoryContainer';

const { Column } = Table;
const { Option } = Select;
const testFunction = (accountName, loan, index, loans) => {
  if (index !== 0 && loan.accountId === loans[index - 1].accountId) {
    return {
      children: <span style={{ marginLeft: 40 }}>&#8627;</span>,
    };
  }
  return {
    children: <span><Link to={`/admin/accounts/${loan.accountId}/profile`}>{accountName}</Link><br />{loan.account.profileData.personalNumber}</span>,
  };
};

const getNumberOfPayments = (loan) => {
  const paidPayments = loan.installments.filter(function (item) {
    return item.status === "PAID";
  }).length;
  return {
    children: <span>{paidPayments}</span>
  };
};

const getCommunication = (loan) => {

  return {
    children: <CommunicationHelper loan={loan}></CommunicationHelper>
  }
}

const phonePlusEmail = (account) => {
  return {
    children: <span>{account.profileData.phone}<br />{account.profileData.email}</span>
  };
};


const pozickyRender = (loan) => {
  return {
    children: (
      <React.Fragment>
        <LoanHistoryContainer accountId={loan.accountId} historyStatus={loanHistoryStatus.CAK} count={loan.cakNum}></LoanHistoryContainer>
        <span>/</span>
        <LoanHistoryContainer accountId={loan.accountId} historyStatus={loanHistoryStatus.AKT} count={loan.schvNum}></LoanHistoryContainer>
        <span>/</span>
        <LoanHistoryContainer accountId={loan.accountId} historyStatus={loanHistoryStatus.UHR} count={loan.zatNum}></LoanHistoryContainer>
        <span>/</span>
        <LoanHistoryContainer accountId={loan.accountId} historyStatus={loanHistoryStatus.ZAM} count={loan.rejNum}></LoanHistoryContainer>
      </React.Fragment>
    ),
  };
};

const displayPaymentValue = (installments) => {
  return {
    children: <span>{installments.length > 0 ? currencyFormatter(installments[0].amount) : ""}</span>
  };
};

const displayStatuses = (status, loan) => {
  let loanStatus = loanStatusT[status];
  let encashStatus = encashmentStatusT[loan.encashmentStatus];
  let earlyRepayment = loan.earlyRepayment;
  if(encashStatus){
    if(earlyRepayment) {
      return {
        children: <div>
                    <span>{loanStatus}</span>
                    <br></br>
                    <span>{encashStatus}</span>
                    <br></br>
                    <span class="text-danger" style={{ wordBreak: "break-word" }}>Žiadosť o predčasné splatenie</span>
                  </div>
      };
    }
    return {
      children: <div>
                  <span>{loanStatus}</span>
                  <br></br>
                  <span>{encashStatus}</span>
                </div>
    };
  } else {
    if (earlyRepayment) {
      return {
        children: <div>
          <span>{loanStatus}</span>
          <br></br>
          <span className="text-danger" style={{ wordBreak: "break-word" }}>Žiadosť o predčasné splatenie</span>
        </div>,
      };
      } else
        return {
        children: <span>{loanStatus}</span>,
    };
  }
}


@translate()
export default class LoanList extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    loans: PropTypes.array.isRequired,
    pagination: PropTypes.object.isRequired,
    filter: PropTypes.object.isRequired,
    onTableChange: PropTypes.func.isRequired,
    onFilterSearchChange: PropTypes.func.isRequired,
    onFilterStatusChange: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isRejectingLoans: PropTypes.bool.isRequired,
    actions: PropTypes.func,
    token: PropTypes.string,
    rejectLoans: PropTypes.func.isRequired,
  };

  static defaultProps = {
    actions: (text, loan) => (
      <span>
        <Link to={`/admin/loans/${loan.id}`}>{t('Detail')}</Link>
      </span>
    ),
  };
  render() {
    const {
      loans,
      pagination,
      filter,
      onTableChange,
      onFilterSearchChange,
      onFilterStatusChange,
      onFilterEncashmentStatusChange,
      onFilterLoanAttributeChange,
      isLoading,
      isRejectingLoans,
      actions,
      t,
      token,
      rejectLoans,
    } = this.props;

    return (
      <div>
        <Row className="filters padded">
          <Col xs={12} sm={4}>
            <Search
              key="loanSearch"
              onSearch={onFilterSearchChange}
            />
          </Col>
          <Col xs={12} sm={2} >
            <Select
              placeholder={t('Vybrať stav')}
              onChange={onFilterStatusChange}
              value={filter.status}
            >
              <Option value="">{t('Všetky stavy')}</Option>
              {Object.entries(loanStatusT).map(([key, value]) => (
                  <Option key={key} value={key}>
                    {value}
                  </Option>
              ))}
            </Select>
          </Col>
          <Col xs={12} sm={2}>
            <Select
              placeholder={t('Vybrať stav inkasa')}
              onChange={onFilterEncashmentStatusChange}
              value={filter.encashmentStatus}
            >
              <Option value="">{t('Všetky stavy')}</Option>
              {Object.entries(encashmentStatusT).map(([key, value]) => (
                <Option key={key} value={key}>
                  {value}
                </Option>
              ))}
            </Select>
          </Col>
          <Col xs={12} sm={2}>
            <Select
                placeholder={t('Vybrať príznak pôžičky')} //premenovať vhodne
                onChange={onFilterLoanAttributeChange}
                value={filter.attribute}
              >
                <Option value="">{t('Všetky príznaky')}</Option>
                {Object.entries(loanAttributeT).map(([key, value]) => (
                  <Option key={key} value={key}>
                    {value}
                  </Option>
                ))}
            </Select>
          </Col>
          <Col xs={12} sm={2}>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button size="small" onClick={rejectLoans} loading={isRejectingLoans}>{t('Prečistiť žiadosti na schválenie')}</Button>
            </div>
          </Col>
        </Row>

        <ResponsiveTable
          dataSource={loans}
          rowKey={loan => loan.id}
          pagination={pagination}
          onChange={onTableChange}
          loading={isLoading}
          rowClassName={loan => loan.blacklist.length > 0 ? 'blacklist-row' : (loan.nonpayer ? 'nonpayer-row' : '')}
        >
          <Column
            title={t('Meno dlžníka / Rodné číslo')}
            dataIndex="accountName"
            key="accountName"
            render={(accountName, loan,index) => testFunction(accountName,loan,index,loans)}
          />
          <Column
            title={t('Telefónne číslo / Email')}
            dataIndex="account"
            key="account"
            render={account => phonePlusEmail(account)}
        />

          <Column
            title={t('Pôžičky  ČAKÁ/AKT/UHR/ZAM')}
            dataIndex="rejNum"
            width="130px"
            key="rejNum"
            render={(_, loan) => pozickyRender(loan)}
          />
          <Column
            title={t('Variabilný symbol')}
            width="160px"
            dataIndex="loanNumber"
            key="loanNumber"
            render={loanNumber => loanNumber}
          />
          <Column
            title={t('Suma')}
            dataIndex="amount"
            key="amount"
            render={amount => currencyFormatter(amount)}
          />
          <Column
            title={t('Mesačná splátka')}
            dataIndex="installments"
            key="installments"
            width="90px"
            render={installments => displayPaymentValue(installments)}
          />
          <Column title={t('Dĺžka v mesiacoch')} dataIndex="months" key="months" width="100px"/>
          <Column title={t('Uhradené splátky')}
            dataIndex="paymentsDone"
            key="paymentsDone"
            width="90px"
            render={(name,loan,index) => getNumberOfPayments(loan)} />
          <Column
            title={t('Systémový stav / Stav inkasa')}
            dataIndex="status"
            key="status"
            render={(status, loan, index) => displayStatuses(status, loan)}
          />

          <Column
            title={t('Dátum vytvorenia')}
            dataIndex="createdAt"
            key="createdAt"
            render={createdAt => formatDateTime(createdAt)}
          />
          <Column
            title={t('Komunikácia')}
            dataIndex="updatedAt"
            key="updatedAt"
            render={(name,loan,index) => getCommunication(loan)}
          />

          <Column title={t('Akcie')} key="action" render={actions} />
        </ResponsiveTable>


        {token && (
          <OpenFileLink
            isButton
            href={`${process.env.REACT_APP_API_URL}/loan/report?token=${token}&status=${filter.status}&search=${filter.search}&attribute=${filter.attribute}&encashmentStatus=${filter.encashmentStatus}`}
          >
            {t('Export')}
          </OpenFileLink>
        )}
        <Button size="small">
          <Link to="/admin/encashmentStatusChange">{t('Zmena stavu')}</Link>
        </Button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/loan-management/components/LoanList.js